import toast from "react-hot-toast";
import { testimonialEndpoints } from "../apis";
import { apiConnector } from "../apiconnector";

const { GET_ALL_TESTIMONIALS, CREATE_YOUTUBE_TESTIMONIAL, UPDATE_YOUTUBE_TESTIMONIAL, DELETE_YOUTUBE_TESTIMONIAL } =
  testimonialEndpoints;

export async function getAllTestimonials() {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_TESTIMONIALS, null);

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    result = response.data.data;
  } catch (error) {
    console.log("GET_ALL_TESTIMONIALS ERROR...", error);
    toast.error("Could not get all testimonials");
  }
  toast.dismiss(toastId);
  return result;
}

export async function createYoutubeTestimonial(data, token) {
  const toastId = toast.loading("Adding testimonial...");
  try {
    const response = await apiConnector(
      "POST",
      CREATE_YOUTUBE_TESTIMONIAL,
      data,
      { Authorization: `Bearer ${token}` }
    );
    if (!response.data.success) throw new Error(response.data.message);
    toast.success("Video testimonial added");
    return response.data.data;
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Could not add video testimonial"
    );
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

export async function updateYoutubeTestimonial(id, data, token) {
  const toastId = toast.loading("Updating testimonial...");
  try {
    const response = await apiConnector(
      "PATCH",
      `${UPDATE_YOUTUBE_TESTIMONIAL}/${id}`,
      data,
      { Authorization:`Bearer ${token}` }
    );
    if (!response.data.success) throw new Error(response.data.message);
    toast.success("Video testimonial updated");
    return response.data.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Could not update video testimonial");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

export async function deleteYoutubeTestimonial(id, token) {
  const toastId = toast.loading("Deleting testimonial...");
  try {
    const response = await apiConnector(
      "DELETE",
      `${DELETE_YOUTUBE_TESTIMONIAL}/${id}`,
      null,
      { Authorization:`Bearer ${token}` }
    );
    if (!response.data.success) throw new Error(response.data.message);
    toast.success("Video testimonial deleted");
    return true;
  } catch (error) {
    toast.error(error.response?.data?.message || "Could not delete video testimonial");
    return false;
  } finally {
    toast.dismiss(toastId);
  }
}
